<ng-container *appTranslate="let t">
  <div class="kpi-section full-width">
    <h2 class="section-title">
      <i [class]="icon() + ' mr-2'"></i>
      {{ t(titleKey()) }}
    </h2>
    <div class="kpi-cards kpi-row">
      @for (kpi of kpis(); track kpi.type) {
        <new-ui-kpi-card [kpi]="kpi" />
      }
    </div>
  </div>
</ng-container>
